import React from "react";

const ApplicantDeclaration = () => {
  return (
    <div>
      <p class="">
        I/We have gone through the Financial and other statement / particulars /
        representations, furnished / made by the company and after careful
        consideration I am / We are making the deposit with the company at my /
        our own risk. I/We declare that the first named depositor is
        beneficial-owner of the deposit and as such he/she should be treated as
        the payee of the purpose of Tax deduction under section 194-A of Tax
        Act, 1961. I/We hereby declare that the details furnished above are true
        and correct to the best of my/our knowledge & belief and I/We undertake
        to inform Sufala Mutual Benefit Nidhi Limited of any change there in
        immediately. In case any of the above information is found incorrect /
        misleading / misrepresenting, I/We may be held liable for it. I/We have
        undersigned read and agree to bind by the Term & Conditions Governing
        the deposit given on the reverse. I/We agree to abide by any future
        amendments/changes in the scheme.
      </p>
    </div>
  );
};

export default ApplicantDeclaration;
